import React from "react";

const SliderPrevIcon = () => (
  <svg
    height="55"
    width="55"
    viewBox="0 18 74 40"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <defs>
      <path id="prev" d="M21.357 5L17 9.467 47.666 37 17 64.534 21.357 69 57 37z" />
      <filter id="prev1" height="200%" width="200%" x="-50%" y="-50%">
        <feOffset dy="3" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation="2" />
        <feColorMatrix in="shadowBlurOuter1" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0" />
      </filter>
    </defs>
    <g fill="none" fillRule="evenodd" transform="matrix(-1 0 0 1 74 0)">
      <use fill="#000" filter="url(#prev1)" xlinkHref="#prev" />
      <use fill="#fefefe" xlinkHref="#prev" />
    </g>
  </svg>
);

export default SliderPrevIcon;
